<template>
  <div class="app-change-evn">
    <EvnSelect :evn-selected.sync="evnSelected" :disableInput="this.stateIsViewState">
      <template v-for="slot in possibleChildSlotsFor('Select')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </EvnSelect>
    <Stepper
      v-if="this.stateIsInputState"
      @next="next()"
      :loading-next="loadingNext"
      :show-prev="false"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import EvnSelect from '@/components/process/generic/ItemisedBills/Select.vue'
import Stepper from '../../../../generic/Stepper.vue'
import { mapActions, mapGetters } from 'vuex'
import slotProxy from '../../../../../mixins/slotProxy'
import gql from 'graphql-tag'
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import preFilledInput from '../../../../../mixins/preFilledInput'

export default {
  name: 'Change',
  data () {
    return {
      currentEvnConfiguration: {
        evn: ''
      },
      loadingNext: false
    }
  },
  components: { EvnSelect, Stepper },
  computed: {
    ...mapGetters('evnSettings', [
      'getStep'
    ]),
    stateIsInputState () {
      return this.getStep === 'changeEvnInput'
    },
    stateIsViewState () {
      return this.getStep === 'changeEvnView'
    },
    currentEvnSettings () {
      return this.currentEvnConfiguration.evn
    }
  },
  mixins: [
    preFilledInput('evnSelected', 'currentEvnSettings'),
    slotProxy()
  ],
  apollo: {
    currentEvnConfiguration: function () {
      return wrapQuery(
        gql`query changeEvnSettings {
          currentEvnConfiguration {
              evn
          }
        }`, this, 'currentEvnConfiguration', {}, null, { fetchPolicy: 'cache-first' }
      )
    }
  },
  methods: {
    ...mapActions('evnSettings', [
      'saveEvnSettings'
    ]),
    async next () {
      this.loadingNext = true
      await this.saveEvnSettings({ selectedEvn: this.evnSelected })
      this.$apollo.queries.currentEvnConfiguration.refetch()
      this.loadingNext = false
    }
  }
}
</script>
